// extracted by mini-css-extract-plugin
export var button = "_db-0";
export var donut = "_db-1";
export var donutFill = "_db-3";
export var donutTrack = "_db-2";